export const FETCH_STUDENT_EXAM_REPORTS = 'FETCH_STUDENT_EXAM_REPORTS';
export const CREATE_EXAM_REPORT = 'CREATE_EXAM_REPORT';
export const DELETE_EXAM_REPORT = 'DELETE_EXAM_REPORT';
